const wrappedContractNames: Record<number, string> = {
  4337: 'WBEAM', // beam
  13337: 'WBEAM', // beam testnet
  13371: 'WIMX', // zkevm
  13473: 'WIMX', // zkevm testnet
  50104: 'WSOPH', // sophon
  531050104: 'WSOPH', // sophon testnet
};
export default wrappedContractNames;
